module.exports = __webpack_public_path__ + "img/role-po.c1e3684d.png";